module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('f7-list', {
    attrs: {
      "media-list": ""
    }
  }, _vm._l((_vm.filteredAccounts), function(accountItem) {
    return _c('f7-list-item', {
      key: accountItem.id,
      attrs: {
        "media": '<div class=\'manualChip\'>' + accountItem.name[0].toUpperCase() + '</div>',
        "title": accountItem.name
      },
      on: {
        "click": function($event) {
          return _vm.switchAccount(accountItem.id)
        }
      }
    }, [_c('f7-swipeout-actions', [_c('f7-swipeout-button', {
      attrs: {
        "data-confirm": "You will not be part of this account anymore",
        "data-confirm-title": "Disengage?",
        "data-close-on-cancel": "true",
        "delete": ""
      }
    }, [_vm._v("\n            Delete\n          ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a0e42d5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0e42d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounts/CMMainPage/CMAccountsList.vue
// module id = 1677
// module chunks = 2